<template>
  <div v-if="showModal" class="news-subscription-dialog">
    <v-dialog
      overlay-opacity="0.97"
      persistent
      v-model="showModal"
      max-width="400"
    >
      <v-card>
        <v-toolbar dense color="#00E676" class="text-h6" dark>
          Subscribe for Full Access
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('close')">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-center text-h6 font-weight-bold pa-4">
          Upgrade your plan to access all news and premium features
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="blue darken-1 white--text"
            text
            @click="$emit('close')"
          >
            Not Now
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1 white--text"
            depressed
            @click="goToPricing"
          >
            Subscribe Now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "NewsSubscriptionModal",

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    goToPricing() {
      this.$router.push({ name: "Pricing" });
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
</style>
